<template>
    <div class="data-box">
        <nav-bar></nav-bar>
        <div class="nav-box-ev">
            <div class="des-box">
                <p>数据洞察  量化分析</p>
                <p>精准捕捉学习动态，优化提升学习策略</p>
            </div>
            <div class="tab-box">
                <div class="tab-child-box">
                    <div v-for="(item, index) in tabOptions" :key="index" class="tab-item" @click="changeTab(item)">
                        <p>{{ item.label }}</p>
                        <!-- <img :src="item.value == currentTab ? item.select : item.noSelect" alt=""> -->
                        <img v-show="item.value == currentTab" :src="item.select" alt="">
                        <img v-show="item.value != currentTab" :src="item.noSelect" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="slider-box">
            <div v-for="(item,index) in tabOptions" @click="scroolTab(item,index)" :class="{active:item.value==currentTab}" class="slider-item" :key="index"></div>
        </div>
        <div class="e-box">
            <div v-if="currentTab == 'course'">
                <div class="echarts-box">
                    <div class="right-slider">
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">课程访问排行</p>
                            <div class="num-box">
                                <span>总学习次数:</span>
                                <span>{{ numberDivide(courseTotalCount) }}</span>
                            </div>
                        </div>
                        <ranking ref="course_vis"></ranking>
                    </div>
                    <div>
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">课程访问统计</p>
                            <div class="num-box">
                                <span>总访问量:</span>
                                <span>{{ numberDivide(courserTotalVisit) }}</span>
                            </div>
                        </div>
                        <div class="chart" id="echart-1"></div>
                    </div>
                </div>
                <div class="echarts-box" style="margin-top: 2rem;">
                    <div class="right-slider">
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">新增课程统计</p>
                            <div class="num-box">
                                    <span>总课程数量:</span>
                                    <span>{{ numberDivide(totalCourseCount) }}</span>
                            </div>
                        </div>
                        <div class="chart" id="echart-2"></div>
                    </div>
                    <div>
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">课程收藏统计</p>
                            <div class="num-box">
                                        <span>总课程数量:</span>
                                        <span>{{ numberDivide(collectCourseCount) }}</span>
                            </div>
                        </div>
                        <div class="chart" id="echart-3"></div>
                    </div>
                </div>
            </div>
            <div v-else-if="currentTab == 'resource'">
                <div class="echarts-box">
                    <div class="resource-ranking right-slider">
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">资源使用排行</p>
                            <div class="num-box">
                                <span>总使用次数:</span>
                                <span>{{ numberDivide(resTotalCount) }}</span>
                            </div>
                        </div>
                        <ranking ref="use_person" type="资源" title="使用次数"></ranking>
                    </div>
                    <div>
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">资源使用统计</p>
                            <div class="num-box">
                                <span>总使用次数:</span>
                                <span>{{ numberDivide(resTotalCount) }}</span>
                            </div>
                        </div>
                        <div class="chart" id="echart-4"></div>
                    </div>
                </div>
                <div class="echarts-box" style="margin-top: 2rem;">
                    <div class="right-slider">
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">分类资源使用统计</p>
                            <div class="num-box">
                                <span>总使用次数:</span>
                                <span>{{ numberDivide(resTotalCount) }}</span>
                            </div>
                        </div>
                        <div class="chart" id="echart-5"></div>
                    </div>
                    <div>
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">分类资源使用占比(%)</p>
                            <div class="num-box">
                                <span>总使用次数:</span>
                                <span>{{ numberDivide(resTotalCount) }}</span>
                            </div>
                        </div>
                        <div class="chart" id="echart-6"></div>
                    </div>
                </div>
                <div class="echarts-box" style="margin-top: 2rem;">
                    <div class="right-slider">
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">新增资源统计</p>
                            <div class="num-box">
                                <span>资源总量:</span>
                                <span>{{ numberDivide(resTotal) }}</span>
                            </div>
                        </div>
                        <div class="chart" id="echart-7"></div>
                    </div>
                    <div>
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">资源占比</p>
                            <div class="num-box">
                                <span>资源总量:</span>
                                <span>{{ numberDivide(resTotal) }}</span>
                            </div>
                        </div>
                        <div class="chart" id="echart-8"></div>
                    </div>
                </div>
            </div>
            <div v-else-if="currentTab=='user'">
                <div class="echarts-box">
                    <div class="right-slider">
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">平台用户角色分布</p>
                            <div class="num-box">
                                <span>总用户数量:</span>
                                <span>{{ numberDivide(roleSumNum) }}</span>
                            </div>
                        </div>
                        <div class="chart" id="echart-9"></div>
                    </div>
                    <div>
                        <div style="display: flex;justify-content: space-between;">
                            <p class="chart-title">平台用户活跃度</p>
                            <div style="color: #8590B3;display: flex;">
                                <div style="display: flex;align-items: center;margin-right: 3rem;">
                                    <div style="width: 8px;height: 8px;background-color: #387DFF;margin-right: 6px;"></div>
                                    <div>周活跃度</div>
                                </div>
                                <div style="display: flex;align-items: center;">
                                    <div style="width: 8px;height: 8px;background-color: #24B899;margin-right: 6px;"></div>
                                    <div>月活跃度</div>
                                </div>
                            </div>
                        </div>
                        <div style="position: relative;width: 100%;height: 100%;">
                            <div v-for="(item,index) in userActiveData" class="active-item" :key="index">
                                <div class="label">{{ item.label }}</div>
                                <div class="progress">
                                    <div class="row" :style="`background-color:${item.color};width:${item.value/activeSum*100}%;`"></div>
                                </div>
                                <text-overflow class="value" :content="item.value"></text-overflow>
                            </div>
                            <div class="splite-box">
                                <div v-for="item in 9" class="splite-item" :key="item"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="e-chart-box" style="margin-top: 2rem;">
                    <p class="chart-title">平台用户增长量</p>
                    <div class="chart" id="echart-11"></div>
                </div>
            </div>
        </div>
        <bottom-slider style="margin-top: 6rem;"></bottom-slider>
    </div>
</template>

<script>
import Ranking from '../components/dataCenter/Ranking.vue';
import { numberDivide } from '@/utils/utils';
import { GetCourseAddStatistics, GetCourseVisitRanking, GetCourseVisitStatistics, GetCourseCollectStatistics, GetResDataUseRanking, GetResDataUseStatistics, GetResDataClassifyUseStatistics, GetResDataUseTotalUseCount, GetResDataClassifyUseProportion, GetResDataAddStatistics, GetResDataProportion,GetPlatformUserRoleDistribution,GetPlatformUserActive,GetPlatformUserAddStatistics,GetCourseCount,GetCourseCollectCount } from '@/api/dataCenter';
import { visitStatistics, courseStatistics, collectStatistics, resourceStatistics, categoryStatistics, categoryUserChart, resourceRateChart,userRoleDistribution,userAddNumber } from '../components/dataCenter/echarts';
import TextOverflow from '../components/common/TextOverflow.vue';
export default {
    components: { Ranking, TextOverflow },
    data() {
        return {
            myChart:null,
            mychart1:null,
            myCharts:[],
            /**总课程数量 */
            totalCourseNum:0,
            /**课程总访问量 */
            courserTotalVisit: 0,
            /**课程总学习次数 */
            courseTotalCount: 0,
            /**资源总使用次数 */
            resTotalCount: 0,
            /**资源总数量 */
            resTotal:'',
            /**课程总数量 */
            totalCourseCount:0,
            /**课程总收藏量 */
            collectCourseCount:0,
            /**平台用户总角色数量 */
            roleSumNum:0,
            /**当前tab */
            currentTab: 'user',
            /**tab选项 */
            tabOptions: [
                {
                    label: '用户数据',
                    value: 'user',
                    select: require('../assets/image/dataCenter/user.png'),
                    noSelect: require('../assets/image/dataCenter/user-no.png')
                },
                {
                    label: '课程数据',
                    value: 'course',
                    select: require('../assets/image/dataCenter/course.png'),
                    noSelect: require('../assets/image/dataCenter/course-no.png')
                },
                {
                    label: '资源数据',
                    value: 'resource',
                    select: require('../assets/image/dataCenter/resource.png'),
                    noSelect: require('../assets/image/dataCenter/resource-no.png')
                },
            ],
            /**平台用户活跃度总数 */
            activeSum:0,
            /**平台用户活跃度数据 */
            userActiveData:[
                {
                    label:'本周',
                    value:100,
                    color:'#387DFF'
                },
                {
                    label:'上周',
                    value:100,
                    color:'#387DFF'
                },
                {
                    label:'本月',
                    value:100,
                    color:'#24B899'
                },
                {
                    label:'上月',
                    value:100,
                    color:'#24B899'
                },
            ],
            timer:null
        }
    },
    methods: {
        numberDivide,
        /**刷新图表 */
        refreshChart(){
            this.myCharts.forEach(item=>{
                item&&item.dispose();
            })
            this.myCharts=[];
            this.$nextTick(() => {
                if (this.currentTab == 'course') {
                   this.getCourseAddStatistics();
                   this.getCourseVisitRanking();
                   this.getCourseVisitStatistics();
                   this.getCourseCollectStatistics();
                    this.getCourseCount();
                   this.getCourseCollectCount();
                } else if (this.currentTab == 'resource') {
                    this.getResDataUseStatistics();
                    this.getResDataClassifyUseStatistics();
                    this.getResDataUseTotalUseCount();
                    this.getResDataClassifyUseProportion();
                    this.getResDataAddStatistics();
                    this.getResDataProportion();
                }else if(this.currentTab == 'user'){
                    this.getPlatformUserRoleDistribution();
                    this.getPlatformUserActive();
                    this.getPlatformUserAddStatistics();
                }
            })
        },
        /**切换tab */
        changeTab(item) {
            if(this.currentTab == item.value)return;
            this.currentTab = item.value;
            this.refreshChart();
        },
        scroolTab(item,index){
            if(this.currentTab == item.value)return;
            this.currentTab = item.value;
            this.refreshChart();
            let dom=document.querySelector('.tab-box');
            var html = document.getElementsByTagName('html')[0];
            if(dom&&html){
                let fontSize=Number(html.style.fontSize.slice(0,-2));
                console.log(fontSize)
                dom.scrollTo({
                    top: 0,
                    left: index*40*fontSize,
                    behavior: 'smooth' // 可选，使滚动平滑进行
                });
            }
        },
        /**获取课程总数 */
        getCourseCount(){
            GetCourseCount().then(res=>{
                if(res.code==200){
                    this.totalCourseCount=res.data;
                }
            })
        },
        /**获取课程收藏数量 */
        getCourseCollectCount(){
            GetCourseCollectCount().then(res=>{
                if(res.code==200){
                    this.collectCourseCount=res.data;
                }
            })
        },
        /**新增课程统计 */
        getCourseAddStatistics() {
            GetCourseAddStatistics().then(res => {
                if (res.code == 200) {
                    var xData = [];
                    var yData = [];
                    res.data.forEach(item => {
                        xData.push(item.month);
                        yData.push(item.addCount);
                    })
                    let chart=courseStatistics('echart-2', xData, yData);
                    this.myCharts.push(chart);
                }
            })
        },
        /**课程访问排行 */
        getCourseVisitRanking() {
            GetCourseVisitRanking().then(res => {
                if (res.code == 200) {
                    var dom = this.$refs['course_vis'];
                    this.courseTotalCount = res.data.length>0?res.data[0].totalStudyCount:0;
                    if (dom&&res.data.length>0) {
                        dom.dataList = res.data;
                        dom.totalStudyCount = res.data[0].totalStudyCount;
                    }else{
                        dom.dataList = [];
                        dom.totalStudyCount = 0;
                    }
                }
            })
        },
        /**课程访问统计 */
        getCourseVisitStatistics() {
            GetCourseVisitStatistics().then(res => {
                if (res.code == 200) {
                    this.courserTotalVisit = res.data[0].totalVisitCount;
                    var xData = [];
                    var yData = [];
                    res.data.forEach(item => {
                        xData.push(item.month);
                        yData.push(item.visitCount);
                    })
                    let chart=this.myChart=visitStatistics('echart-1', xData, yData);
                    this.myCharts.push(chart);
                }
            })
        },
        /**课程收藏统计 */
        getCourseCollectStatistics() {
            GetCourseCollectStatistics().then(res => {
                if (res.code == 200) {
                    var xData = [];
                    var yData = [];
                    res.data.forEach(item => {
                        xData.push(item.month);
                        yData.push(item.collectCount);
                    })
                    let chart=collectStatistics('echart-3', xData, yData);
                    this.myCharts.push(chart);
                }
            })
        },
        /**资源使用排行 */
        getResDataUseRanking(total = 0) {
            GetResDataUseRanking().then(res => {
                if (res.code == 200) {
                    var dom = this.$refs['use_person'];
                    if (dom) {
                        dom.dataList = res.data.map(item => {
                            return {
                                courseName: item.resName,
                                studyNumberCount: item.useCount,
                            }
                        });
                        dom.totalStudyCount = total;
                    }
                }
            })
        },
        /**资源使用统计 */
        getResDataUseStatistics() {
            GetResDataUseStatistics().then(res => {
                console.log(res,'rrr')
                if (res.code == 200) {
                    var obj = {
                        '仿真软件': [],
                        '模型': [],
                        '视频': [],
                        '动画': [],
                        'ppt': [],
                        '试卷': [],
                        '图片': [],
                        '文档': []
                    };
                    var xData = [];
                    for (let key in res.data) {
                        xData.push(key);
                        for (let k in obj) {
                            var el = res.data[key].find(item => item.type == k);
                            if (el) {
                                obj[k].push(el.useCount);
                            } else {
                                obj[k].push(0);
                            }
                        }
                    }
                    obj['软件']=obj['仿真软件'];
                    delete obj['仿真软件'];
                    let chart=resourceStatistics('echart-4', xData, obj);
                    this.myCharts.push(chart);
                }
            })
        },
        /**资源分类使用统计 */
        getResDataClassifyUseStatistics() {
            GetResDataClassifyUseStatistics().then(res => {
                if (res.code == 200) {
                    var xData = [];
                    var last = [];
                    var current = [];
                    res.data.forEach(item => {
                        xData.push(item.classifyName);
                        last.push(item.lastMonthUseCount);
                        current.push(item.currentMonthUseCount);
                    })
                    let chart=categoryStatistics('echart-5', xData, last, current);
                    this.myCharts.push(chart);
                }
            })
        },
        /**获取资源总使用量 */
        getResDataUseTotalUseCount() {
            GetResDataUseTotalUseCount().then(res => {
                if (res.code == 200) {
                    this.resTotalCount = res.data;
                    this.getResDataUseRanking(res.data);
                }
            })
        },
        /**资源分类使用占比统计 */
        getResDataClassifyUseProportion() {
            GetResDataClassifyUseProportion().then(res => {
                if (res.code == 200) {
                    let data = res.data.map(item => {
                        return {
                            name: item.classifyName,
                            value: item.useCount
                        }
                    })
                    let chart=categoryUserChart('echart-6', data);
                    this.myCharts.push(chart);
                }
            })
        },
        /**资源类型新增统计 */
        getResDataAddStatistics() {
            GetResDataAddStatistics().then(res => {
                if (res.code == 200) {
                    var obj = {
                        '仿真软件': [],
                        '模型': [],
                        '视频': [],
                        '动画': [],
                        'ppt': [],
                        '试卷': [],
                        '图片': [],
                        '文档': []
                    };
                    var xData = [];
                    for (let key in res.data) {
                        xData.push(key);
                        for (let k in obj) {
                            var el = res.data[key].find(item => item.type == k);
                            if (el) {
                                obj[k].push(el.addCount || 0);
                            } else {
                                obj[k].push(0);
                            }
                        }
                    }
                    obj['软件']=obj['仿真软件'];
                    delete obj['仿真软件'];
                    let chart=resourceStatistics('echart-7', xData, obj);
                    this.myCharts.push(chart);
                }
            })
        },
        /**资源占比 */
        getResDataProportion() {
            GetResDataProportion().then(res => {
                if (res.code == 200) {
                    var data = res.data.map(item => {
                        return {
                            name: item.type,
                            value: item.resCount
                        }
                    })
                    this.resTotal=res.data[0].resTotalCount;
                    const el=data.find(item=>{
                        return item.name=='仿真软件';
                    })
                    if(el){
                        el.name='软件';
                    }
                    let chart=resourceRateChart('echart-8', data, res.data[0].resTotalCount);
                    this.myCharts.push(chart);
                }
            })
        },
        /**平台用户角色分布 */
        getPlatformUserRoleDistribution(){
            GetPlatformUserRoleDistribution().then(res=>{
                if(res.code==200){
                    var sum=0;
                    var data=res.data.map((item)=>{
                        sum=sum+Number(item.count);
                        return {
                            name:item.roleType,
                            value:item.count
                        }
                    })
                    this.roleSumNum=sum;
                    let chart=userRoleDistribution('echart-9',data);
                    this.myCharts.push(chart);
                }
            })
        },
        /**平台用户活跃度 */
        getPlatformUserActive(){
            GetPlatformUserActive().then(res=>{
                if(res.code==200){
                    res.data.forEach(item=>{
                        let e=this.userActiveData.find(el=>el.label==item.activeTime);
                        if(e){
                            e.value=item.activeCount;
                        }
                        this.activeSum=this.activeSum+item.activeCount;
                    })
                }
            })
        },
        /**平台用户增长量 */
        getPlatformUserAddStatistics(){
            GetPlatformUserAddStatistics().then(res=>{
                if(res.code==200){
                    var currentData=[];
                    var addData=[];
                    var xData=[];
                    res.data.forEach(item=>{
                        currentData.push(item.cumulativeUserCount);
                        addData.push(item.newUserCount);
                        xData.push(item.month);
                    })
                    let chart=userAddNumber('echart-11',currentData,addData,xData);
                    this.myCharts.push(chart);
                }
            })
        },
        resize(){
            this.myCharts.forEach(item=>{
                item&&item.resize();
            })
        }
    },
    mounted() {
        this.getPlatformUserRoleDistribution();
        this.getPlatformUserActive();
        this.getPlatformUserAddStatistics();
        window.addEventListener('resize',this.resize);
        this.timer=setInterval(()=>{
            this.refreshChart();
        },5*60000)
    },
    destroyed(){
        window.removeEventListener('resize',this.resize);
        this.timer&&clearInterval(this.timer);
    }
}
</script>

<style lang="less" scoped>
.data-box {
    background-color: rgb(247,247,249);
    overflow: hidden;
}

.e-box {
    padding: 6rem var(--padding) 0 var(--padding);
    position: relative;
    z-index: 3;
}
.e-chart-box{
    width: 100%;
    height: 38rem;
    border-radius: 10px;
    background: #ffffff;
    border: 1px solid #e8ecef;
    padding: 2.5rem;
}
.echarts-box {
    width: 100%;
    height: 38rem;
    border-radius: 10px;
    background: #ffffff;
    border: 1px solid #e8ecef;
    display: flex;
    padding: 2.5rem;

    &> :nth-child(n) {
        flex: 1;
    }
}

.chart-title {
    color: #334681;
    font-size: 16px;
    font-weight: 700;
}

.resource-ranking {
    /deep/.progress {
        background: linear-gradient(-90deg, #77d5c1 0%, #26b99a 100%);
    }

    /deep/.count-to {
        color: #26B99A;
    }

    /deep/.percent {
        color: #26B99A;
    }
}

.chart {
    width: 100%;
    height: 100%;
}

.num-box {
    color: #8590b3;

    &> :nth-child(2) {
        font-weight: 700;
    }
}

.nav-box-ev {
    min-height: 35rem;
    margin-top: 8.5rem;
    background-image: url('../assets/image/dataCenter/banner.png');
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    padding: 10rem 0;
    .h1 {
        font-size: 4.8rem;
        font-weight: 700;
        color: #1E263D;
        margin-top: 20rem;
        text-align: center;
    }
}
.des-box{
    margin-left: var(--padding);
    margin-top: -5rem;
    padding: 0 5rem;
    &> :nth-child(1){
        color: #3972FF;
        // font-size: 6rem;
        font-size: var(--bigTitle);
        font-weight: 700;
    }
    &> :nth-child(2){
        color: #7C9DDE;
        // font-size: 3.6rem;
        font-size: var(--smallTitle);
        margin-top: 2rem;
    }
}
.tab-box {
    width: calc(100% - 2*var(--padding));
    position: absolute;
    left: var(--padding);
    right: var(--padding);
    bottom: 0;
    z-index: 90;
    overflow: auto;
    .tab-child-box{
        display: flex;
        justify-content: space-between;
        padding: 0 2px;
        column-gap: 2rem;
    }
    .tab-item {
        position: relative;
        cursor: pointer;
        img{
            width: 38rem;
            height: 9.7rem;
        }
        &>p {
            position: absolute;
            top: 3rem;
            left: 3rem;
            font-size: 2.4rem;
            font-weight: 700;
            color: #1E263D;
        }
    }
}
.active-item{
    display: flex;
    align-items: center;
    margin-top: 4.5rem;
    .label{
        color: #8590B3;
        margin-right: 1rem;
    }
    .progress{
        flex: 1;
        background-color: #E9EAEF;
        height: 12px;
        border-radius: 5px;
        position: relative;
        .row{
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            border-radius: 5px;
            z-index: 2;
        }
    }
    .value{
        color: #334681;
        margin-left: 1rem;
        width: 4rem;
    }
}
.splite-box{
    width: calc(100% - 9.5rem);
    height: calc(100% - 8.5rem);
    // background-color: rgba(38, 185, 154,.3);
    position: absolute;
    top: -1.5rem;
    left: 4.5rem;
    display: flex;
    justify-content: space-between;
    .splite-item{
        width: 1px;
        height: 100%;
        background-color: #EAEBF0;
        z-index: 1;
    }
}
.right-slider{
    margin-right: 10rem;
}
@media screen and (max-width:750px){
    .des-box{
        margin-left: 0;
        white-space: normal;
    }
    .slider-box{
        display: flex;
        gap: 1rem;
        justify-content: center;
        margin-top: 3rem;
        .slider-item{
            width: 1rem;
            height: 1rem;
            background-color: #BCC8DE;
            border-radius: 50%;
            cursor: pointer;
            transition: all 0.3s;
        }
        .active{
            width: 2rem;
            background-color: var(--blue);
            border-radius: 1rem;
        }
    }
    .echarts-box{
        display: block;
    }
    .right-slider{
        margin-right: 0;
    }
    .echarts-box{
        height: auto;
        &> :nth-child(n){
            height: 38rem;
        }
        &> :nth-child(2){
            margin-top: 5rem;
        }
    }
    .e-box{
        padding-top: 3rem !important;
    }
}
</style>